var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { v4 as uuidv4 } from 'uuid';
let DinapsisFileOptionsUploader = class DinapsisFileOptionsUploader extends LitElement {
    constructor() {
        super(...arguments);
        this.file = null;
        /**
         * A property that is used to set the file options container unique id
         */
        this.fileOptionsId = `uploader-file-options-container-${uuidv4()}`;
    }
    /**
     * The createRenderRoot function is a function that is called by the lit-html library to tell the
     * component where to render the html.
     * @returns The element itself.
     */
    createRenderRoot() {
        return this;
    }
    /**
     * The function returns a string of HTML that contains a div that contains the component.
     * @returns The return statement is returning the html template literal
     */
    render() {
        return html `
      <div id="${this.fileOptionsId}">Descargar | Eliminar | File ${this.file} </div>
    `;
    }
};
__decorate([
    property({ type: File })
], DinapsisFileOptionsUploader.prototype, "file", void 0);
DinapsisFileOptionsUploader = __decorate([
    customElement('dinapsis-file-options-uploader')
], DinapsisFileOptionsUploader);
export { DinapsisFileOptionsUploader };
//# sourceMappingURL=dinapsis-file-options-uploader.js.map